import App from "./App.svelte";
import practices from "./practices.js";

let urlParams = new URLSearchParams(window.location.search);

let practiceId = urlParams.get("s");

console.log(practices[practiceId]);

const app = new App({
  target: document.body,
  props: {
    practices,
    practice: practices[practiceId]
  }
});

export default app;
